module.exports = __webpack_public_path__ + "img/840.7c3928bd.svg";